import React from 'react';
import { Indicator, PositiveIndicator, NegativeIndicator } from '@contently/toolkit';

export default ({ value }) => {
  const indicatorMapping = {
    accepted: PositiveIndicator,
    declined: NegativeIndicator,
    awaiting_review: Indicator
  };

  const RenderedIndicator = indicatorMapping[value.status];

  return <RenderedIndicator text={value.statusHumanize} />;
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/content_requests/ContentRequestStatusIndicator.jsx